import { useState } from "react";
import { Link } from "react-router-dom";
import InputField from "../../../components/ui/InputField";
import { Button } from "../../../components/ui/Button";
import AuthLayout from "../../../layouts/AuthLayout";
import api from "../../../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  // Backend always returns the same generic message whether or not the
  // email matches an account (api.js's forgotPassword -> POST
  // /login/forgot-password) - don't give it its own meaning here either.
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to send reset link");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout>
      <h2 className="text-2xl font-bold mb-6 text-center">Forgot Password</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}

      {sent ? (
        <div className="text-center">
          <p className="text-secondary-700 mb-6">
            If <span className="font-semibold">{email}</span> is registered, a password reset link has been sent to it.
            The link expires in 30 minutes.
          </p>
          <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700">
            ← Back to Login
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <p className="text-sm text-gray-600 mb-4">
            Enter your login email and we'll send you a link to reset your password.
          </p>
          <InputField
            label="Email ID"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-label="Forgot Password Email Input"
          />
          <Button type="submit" disabled={submitting} className="w-full">
            {submitting ? "Sending..." : "Send Reset Link"}
          </Button>
          <div className="text-center mt-4">
            <Link to="/" className="text-sm font-medium text-gray-500 hover:text-gray-700">
              ← Back to Login
            </Link>
          </div>
        </form>
      )}
    </AuthLayout>
  );
}
